export const MAX_FILTERS = 2;
